import { Pipe, PipeTransform } from '@angular/core';

/**Pipe che trasforma il testo per inserirlo in un matTooltip, rimuovendo i tag span ed estraendone una sottostringa */
@Pipe({
  name: 'sintexTooltip'
})
export class SintexTooltipPipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia che effettua la trasformazione da stringa iniziale a finale
   * @param value {string} stringa iniziale da trasformare
   * @param startIndex {number} indice di inizio sottostringa
   * @param endIndex {number} indice di fine sottostringa
   * @returns {any}
   */
  transform(value: string, startIndex: number, endIndex: number): any {
    let modString = value.replace(/<span class="italic" style="font-style: italic;">/g,'').replace(new RegExp('</span>', 'g'),'').substring(startIndex,endIndex);
    modString = modString + '[...]';
    return modString;
  }

}
